<template>
	<div class="home">
		<my-header active="1" />
		<div class="main">
			<div class="container">
				<div class="top">
					<div class="left">
						<el-carousel height="200px">
							<el-carousel-item v-for="(item,index) in imgList" :key="index">
								<img :src="item.img" alt="">
							</el-carousel-item>
						</el-carousel>
						<div class="erweima">
							<!-- <img src="../assets/images/public/erweima.png" />
							<h1>官方微信公众号</h1> -->
							<h3>证书查询</h3>
							<div class="divider"></div>
							<el-form :model="ruleForm" ref="ruleForm" label-width="93px" class="demo-ruleForm">
								<el-form-item prop="name">
									<label slot="label">姓&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;名：</label>
									<el-input v-model="ruleForm.chineseName"></el-input>
								</el-form-item>
								<el-form-item label="证件号码：" prop="idcard">
									<el-input v-model="ruleForm.documentNo"></el-input>
								</el-form-item>	
								<el-form-item label="证书编号：" prop="idcard">
									<el-input v-model="ruleForm.cermOn"></el-input>
								</el-form-item>															
								<el-button @click="submitForm" type="primary">查 &nbsp;&nbsp;&nbsp;&nbsp;询</el-button>							
							</el-form>
						</div>
					</div>
					<div class="Middle">
						<div class="topHeader">
							<img src="../assets/images/public/dongtaixiaoxi.jpg" alt="">
							<!-- <el-button type="text">MORE+</el-button> -->
							<router-link to="/list/0">
								<span>MORE+</span>
							</router-link>
						</div>
						<div class="donglist">
							<ul>
								<li v-for="item in dynamiclist1" @click="see(item.id)" :key="item.id">
									<b>{{ item.createDate | dateTime('MM-dd') }}</b>
									<span></span>
									{{item.name}}
								</li>
							</ul>
							<p v-if="!dynamiclist1.length">暂无数据</p>
						</div>
						<div class="topHeader">
							<img src="../assets/images/public/xiangmujiesao.jpg" alt="">
							<!-- <el-button type="text">MORE+</el-button> -->
							<router-link to="/list/2">
								<span>MORE+</span>
							</router-link>
						</div>
						<div class="donglist">
							<ul>
								<li v-for="item in dynamiclist2" @click="see(item.id)" :key="item.id">
									<b>{{ item.createDate | dateTime('MM-dd') }}</b>
									<span></span>
									{{item.name}}
								</li>
							</ul>
							<p v-if="!dynamiclist2.length">暂无数据</p>
						</div>
					</div>
					<div class="right">
						<a>
							<img src="../assets/images/public/zhengshuchaxun.jpg" alt="">
						</a>
						<examination-sidebar />
					</div>
				</div>
				<div class="banners">
					<el-carousel height="200px">
						<el-carousel-item v-for="(item,index) in bannerList" :key="index">
							<img :src="item.banner" alt="">
						</el-carousel-item>
					</el-carousel>
				</div>
				<div class="bottom">
					<div class="left">
						<div class="topHeader">
							<img src="../assets/images/public/zhengshujieshao.jpg" alt="">
							<!-- <el-button type="text">MORE+</el-button> -->
							<router-link to="/list/3">
								<span>MORE+</span>
							</router-link>
						</div>
						<div class="donglist">
							<ul>
								<li v-for="item in dynamiclist3" @click="see(item.id)" :key="item.id">
									<span></span>
									{{item.name}}
								</li>
							</ul>
							<p v-if="!dynamiclist3.length">暂无数据</p>
						</div>
					</div>
					<div class="Middle">
						<div class="topHeader">
							<img src="../assets/images/public/kaoshigonggao.jpg" alt="">
							<!-- <el-button type="text">MORE+</el-button> -->
							<router-link to="/examinationNotice">
								<span>MORE+</span>
							</router-link>
						</div>
						<div class="donglist">
							<ul>
								<li v-for="item in dynamiclist4" @click="see(item.id)" :key="item.id">
									<b>{{ item.createDate | dateTime('MM-dd') }}</b>
									<span></span>
									{{item.name}}
								</li>
							</ul>
							<p v-if="!dynamiclist4.length">暂无数据</p>
						</div>
					</div>
					<div class="right">
						<div class="topHeader">
							<img src="../assets/images/public/zhengcewenjian.png" alt="">
							<span class="zcgcTitle">政策规则</span>
							<!-- <el-button type="text">MORE+</el-button> -->
							<router-link to="/list/5">
								<span>MORE+</span>
							</router-link>
						</div>
						<div class="donglist">
							<ul>
								<li v-for="item in dynamiclist5" @click="see(item.id)">
									<span></span>
									{{ item.name }}
								</li>
							</ul>
							<p v-if="!dynamiclist5.length">暂无数据</p>
						</div>
					</div>
				</div>
				<div class="imgs">
					<img src="../assets/images/public/youqinglianjie.jpg" alt="">
					<div>
						<a :href="item.address" v-for="item in linkList" target="_blank">
							<img :src="item.picturePath" alt="">
						</a>
					</div>
				</div>
			</div>
		</div>
		<my-footer />
		<el-dialog
			:append-to-body="true"
			custom-class="learnDialog"
			title="查询结果     Search Result"
			:visible.sync="dialogVisible"
			width="80%">
			<div class="el-dialog__header"></div>
			<div v-if="userInfo.children.length>0">
				<h3><i class="el-icon-tickets"></i> 基本信息&nbsp; BASIC &nbsp;INFORMATION</h3>
			<el-row>
				<el-col :span="6" class="titlebox"><span>姓名</span><span>Name</span></el-col>
				<el-col :span="6" class="labelbox">
					<span>{{userInfo.chineseName}}</span>
					<span>{{ userInfo.englishName }}</span>
				</el-col>
				<el-col :span="6" class="titlebox"><span>性别</span><span>Gender</span></el-col>
				<el-col :span="6" class="labelbox">
					<span>{{ userInfo.sex }}</span>
					<span>{{ userInfo.englishSex }}</span>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="6" class="titlebox"><span>证件号码</span><span>ID Card NO.</span></el-col>
				<el-col :span="6">{{ userInfo.documentNo }}</el-col>
				<el-col :span="6"></el-col>
				<el-col :span="6"></el-col>
			</el-row>	
			<h3><i class="el-icon-s-platform"></i> 成绩 &nbsp; EXAMNATION &nbsp; RESULT</h3>
			<el-row>
				<el-col :span="12" class="labelbox" style="text-align:center">
					<span>{{ userInfo.score }}</span>
					<span>{{ userInfo.englishScore }}</span>
				</el-col>
				<el-col :span="12"></el-col>
			</el-row>
			<div v-for="(item,index) in userInfo.children" :key="index">
				<h3><i class="el-icon-postcard"></i> 证书信息 &nbsp; CERTIFICATE &nbsp; INFOMAITO</h3>
				<el-row>
					<el-col :span="6" class="titlebox"><span>证书名称</span><span>Certificate Name</span></el-col>
					<el-col :span="6" class="labelbox"><span>{{  item.certName}}</span><span>{{ item.englishCertName }}</span></el-col>
					<el-col :span="6" class="titlebox"><span>级别</span><span>Level</span></el-col>
					<el-col :span="6" class="labelbox"><span>{{ item.level }}</span><span>{{ item.englishLevel }}</span></el-col>
				</el-row>
				<el-row>
					<el-col :span="6" class="titlebox"><span>证书号码</span><span>Certificate NO.</span></el-col>
					<el-col :span="6">{{ item.cermOn }}</el-col>
					<el-col :span="6" class="titlebox"><span>区域</span><span>Region</span></el-col>
					<el-col :span="6">{{ item.region }}</el-col>
				</el-row>
			</div>	
			</div>
			<el-empty v-else description="暂无数据"></el-empty>
		</el-dialog>
	</div>
</template>

<script>
import { getInfo } from '@/api/user'
import { articleList, linkListPage,certificate } from '@/api/cms'
import { noticeMyList } from '@/api/center'
export default {
	name: 'home',
	components: {
		
	},
	data(){
            return {
                imgList:[{
					img:require('../assets/images/public/timg1.png'),
				},{
					img:require('../assets/images/public/timg2.png'),
				},{
					img:require('../assets/images/public/timg3.png'),
				},{
					img:require('../assets/images/public/timg4.png'),
				},{
					img:require('../assets/images/public/timg5.png'),
				},],
				bannerList:[{
					banner:require('../assets/images/public/foot1.png'),
				},{
					banner:require('../assets/images/public/foot2.png'),
				},{
					banner:require('../assets/images/public/foot3.png'),
				},{
					banner:require('../assets/images/public/foot4.png'),
				},],
				linkList: [],
				dynamiclist1: [],
				dynamiclist2: [],
				dynamiclist3: [],
				dynamiclist4: [],
				dynamiclist5: [],
				dialogVisible:false,
				//证书查询表单
				ruleForm:{
					
				},
				//用户基本信息
				userInfo:{
					chineseName:'',//用户名称
					englishName:'',
					sex:'',//性别
					englishSex:'',
					documentNo:'',//证件号码
					score:'',//成绩
					englishScore:'',
					children:[]
				},

            }
        },
	mounted(){
		linkListPage({pageNum: 1, pageSize: 5, type: 1}).then(res => {
		    this.linkList = res.list
		})
		articleList({ pageNum: 1, pageSize: 6, type: 0 }).then(res => {
			if(res.list){
				this.dynamiclist1 = res.list
			}
		})
		articleList({ pageNum: 1, pageSize: 6, type: 2 }).then(res => {
			if(res.list){
				this.dynamiclist2 = res.list
			}
		})
		articleList({ pageNum: 1, pageSize: 9, type: 3 }).then(res => {
			if(res.list){
				this.dynamiclist3 = res.list
			}
		})
		articleList({ pageNum: 1, pageSize: 9, type: 4 }).then(res => {
			if(res.list){
				this.dynamiclist4 = res.list
			}
		})
		articleList({ pageNum: 1, pageSize: 9, type: 5 }).then(res => {
			if(res.list){
				this.dynamiclist5 = res.list
			}
		})
	},
	methods:{
		see(id,type){
			this.$router.push({
                path: '/articleDetails',
                // name: 'mallList',
                query: {
					id,
					type
                }
            })
		},
		reset(){
			this.userInfo={
				chineseName:'',//用户名称
				englishName:'',
				sex:'',//性别
				englishSex:'',
				documentNo:'',//证件号码
				score:'',//成绩
				englishScore:'',
				children:[]
			}
		},
		//证书查询
		submitForm(){	
			let arrList=Object.values(this.ruleForm)	
			let isvalid=arrList.filter((item)=>item!=''&&item!=null)
			if(isvalid.length>1){			
				let data={
					pageNum:1,
					pageSize:999,
					sortKey:'level_sort',
					sortValue:'desc',
					...this.ruleForm
				}
				this.reset();
				certificate(data).then(res=>{
					if(res.list.length>0){
						this.userInfo.chineseName=res.list[0].chineseName//用户名称
						this.userInfo.englishName=res.list[0].englishName
						this.userInfo.sex=res.list[0].sex//性别
						this.userInfo.englishSex=res.list[0].englishSex
						this.userInfo.documentNo=res.list[0].documentNo//证件号码
						this.userInfo.score=res.list[0].score//成绩
						this.userInfo.englishScore=res.list[0].englishScore
						this.userInfo.children=res.list//证书列表										
					}
					console.log(this.userInfo)
					this.dialogVisible=true				
				})			
			}else{
				this.$message.error('请至少填写两项')
			}
		}
	}
}
</script>

<style scoped>
.top{
	display: flex;
	justify-content: space-between;
	padding-top: 20px;
	/* margin-bottom: 20px; */
}
.left{
	width: 320px;
}
.top .erweima{
	margin-top: 32px;
	padding: 20px;
	text-align: center;
	border: 1px solid #ebd388;
}
.top .erweima img{
	width: 225px;
	height: 225px;
}
.top .erweima h1{
	font-size: 24px;
	font-weight: bold;
	color: #3d63a1;
}
.top .right >>> .examinationSidebar{
	margin-right: 0;
}
.top .right>>>.block{
	margin-bottom: 4px;
}
.topHeader{
	height: 40px;
	position: relative;
}
.topHeader span{
	font-size: 14px;
	color: #666;
	position: absolute;
	right: 25px;
	height: 40px;
	line-height: 40px;
}
.donglist{
	width: 617px;
	height: 220px;
	border: 1px solid #ebd388;
	border-top:0;
	margin-bottom: 18px;
}
.donglist p{text-align: center;line-height: 80px;}
.donglist ul li {
	padding: 0 15px;
	line-height: 36px;
	display: flex;
    justify-content: flex-start;
    align-items: center;
}
.donglist ul li span:nth-of-type(1){
	display: inline-block;
	width: 7px;
	height: 7px;
	border-radius: 50%;
	background-color: #ffc000;
	margin-right: 7px;
}
.donglist ul li span:nth-of-type(2){
	font-size: 14px;
}
.bottom{
	display: flex;
	justify-content: space-between;
	padding-top: 10px;
}
.bottom .left .topHeader{
	height: 49px;
}
.bottom .left .topHeader span{
	line-height: 56px;
}
.bottom .donglist{
	width: 317px;
	height: 310px;
}
.bottom .donglist ul li{
	line-height: 34px;
}
.bottom .Middle{
	padding-top: 10px;
}
.bottom .Middle .donglist{
	width: 515px;
	height: 310px;
}
/*.bottom .Middle .donglist ul li span{
	font-weight: bold;
}
.bottom .Middle .donglist ul li{
	line-height: 62px;
}*/
.bottom .right .topHeader{
	height: 49px;
}
.bottom .right .topHeader span{
	line-height: 56px;
}
.imgs{
	display: flex;
	justify-content: flex-start;
	margin-bottom: 20px;
}
.imgs>img{
	width: 145px;
	height: 100px;
}
.imgs>div{
	width: 100%;
	border: 1px solid #ebd388;
	height: 100px;
	box-sizing: border-box;
	padding: 20px;
}
.imgs>div img+img{
	margin-left: 20px;
}
.donglist ul li span{
	width: 100%;
	overflow:hidden;
    text-overflow:ellipsis;
    white-space:nowrap
}
.donglist ul li{
	cursor:pointer;
}
.imgs div img{width: 186px;height: 64px;margin-right: 20px;}
.imgs div a:last-child img{margin-right: 0;}
.donglist li{display: block !important;overflow: hidden; white-space: nowrap; text-overflow: ellipsis;}
.donglist li b{font-weight: normal;float: right;}
.divider{
	display: block;
    height: 1px;
    width: 100%;
    margin: 12px 0;
	background: #dcdfe6;
}
 .topHeader .zcgcTitle{
	left: 40px;
    font-weight: 600;
    color: #b63638;
    font-size: 16px;
    opacity: 0.88;
}
.el-button--primary{
	background-color: #dcdfe6 !important;
    border-color: #dcdfe6 !important;
	color: #67699a;
	font-weight: 600;
	width: 100%;
	padding:9px 20px;
}
.el-form-item{
	margin-bottom: 18.8px;
}
.el-row{
	border: 1px solid #000;
}
.el-col{
	border-right: 1px solid #000;
	height: 57px;
	line-height: 57px;
	color: #000;
	font-size: 16px;
	padding-left: 8px;
	font-family: math;
}
h3{
	font-size: 16px;
	background: #015293;	
    height: 34px;
    line-height: 34px;
    font-weight: 600;
    color: #ffff;
    padding-left: 10px;
}
.titlebox{
	text-align: right;
	font-weight: 600;
	padding-right: 8px;
	display: flex;
	flex-direction: column;
	justify-content: center;
	line-height: initial;
}
.labelbox{
	display: flex;
	flex-direction: column;
	justify-content: center;
	line-height: initial;
}
.titlebox span{
	font-family: math;
}
.el-dialog__header{
	background: #1f81c7 !important;
	height: 1px;
    width: 96%;
    padding: 0;
    position: absolute;
    top: 52px;
    left: 20px;
}
.el-empty__description p{
	font-size: 16px;
}
</style>
